import type { TClienteRegimeCasamentoEnum } from './proposta'

export const EstadoCivilEnum = {
  CivilSolteiro: 'CivilSolteiro',
  CivilCasado: 'CivilCasado',
  CivilDivorciado: 'CivilDivorciado',
  CivilViuvo: 'CivilViuvo',
  CivilUniaoEstavel: 'CivilUniaoEstavel',
  CivilSeparadoJudicialmente: 'CivilSeparadoJudicialmente',
} as const
export type TEstadoCivilEnum = (typeof EstadoCivilEnum)[keyof typeof EstadoCivilEnum]

export type TCreateCadastrarClienteResponse = {
  id: string
  message: string
  date: string
  data: TCreateCadastrarClienteData
}

export type TCreateCadastrarClienteData = {
  cpf: string
  email: string
  estadoCivil: string | null
  maiorDe18Anos: boolean
  nacionalidadeId: string
  nome: string
  possuiUniaoEstavel: boolean | null
  profissaoId: string
  regimeCasamento: string | null
  telefone: TTelefone | null
  tipoDoCliente: TTipoDeCliente
}

export type TEndereco = {
  cidade: string
  uf: string
}

export type TProfissao = {
  id: string
  descricao: string
}

export type TNacionalidade = {
  id: string
  descricao: string
}

export type TTelefone = {
  numero: string
  principal: boolean
  origem: 'Brasil' | 'Internacional'
}

export type TCliente = {
  id: string
  cpf?: string | null
  nome: string
  imagem?: string
  resumo?: string
  estadoCivil?: TEstadoCivilEnum | null
  filhos?: number
  proprietario?: boolean
  nomeConjuge?: string
  empreendimentos?: string[]
  vendedorAlocadoId?: string
  telefone: TTelefone | null
  endereco?: { cidade: string; uf: string }
  unidadeDeNegocioId?: string
  profissao?: { id: string; descricao: string } | null
  nacionalidade?: { id: string; descricao: string }
  tipoDoCliente: TTipoDeCliente
  email?: string | null
  possuiUniaoEstavel?: boolean | null
  maiorDe18Anos?: boolean
  regimeCasamento?: TClienteRegimeCasamentoEnum
  ativo: boolean
}

export type TClienteSimplificado = {
  id?: string
  nome: string
  cpf: string | null
  profissao?: string
  telefonePrincipal: string
  imagemDaPessoa: string | null
  endereco?: TEndereco
  tipoDoCliente: TTipoDeCliente
}

export const tipoDeCliente = {
  Lead: 'Lead',
  Contato: 'Contato',
  LeadRepresado: 'LeadRepresado',
} as const
export type TTipoDeCliente = (typeof tipoDeCliente)[keyof typeof tipoDeCliente]
